import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    DrawerBody,
    DrawerCloseButton,
    DrawerContainer,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Icon,
} from '@spothero/ui';
import IconBuildings from '@spothero/icons/buildings';

import Badge from 'common/badge/Badge';
import SearchWindow from 'common/facility-sidebar/search-window/SearchWindow';
import FacilitySidebarHeader from 'common/facility-sidebar/FacilitySidebarHeader';

const facilityMenuButtonStyleProps = {
    variant: 'tertiary',
    flexDirection: 'column',
    gap: 1,
    height: 12,
    width: 20,
    color: 'black',
    fontSize: 'xs',
};

const selectedFacilitiesBadgeStyleProps = {
    variant: 'subtle',
    backgroundColor: 'primary.100',
    color: 'primary.600',
};

const MobileFacilitySelectionMenu = ({
    areFiltersOpen,
    onFiltersToggle,
    handleFacilitySelectionMenuToggel,
    isFacilitiesMenuOpen,
    numberOfSelectedFacilities,
    userEmail,
}) => {
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <>
            <Button
                onClick={handleFacilitySelectionMenuToggel}
                {...facilityMenuButtonStyleProps}
            >
                <Icon as={IconBuildings} boxSize={6} />
                <Badge {...selectedFacilitiesBadgeStyleProps}>
                    {numberOfSelectedFacilities} Selected
                </Badge>
            </Button>
            <DrawerContainer
                isOpen={isFacilitiesMenuOpen}
                onClose={handleFacilitySelectionMenuToggel}
                blockScrollOnMount
                placement="left"
                size="full"
            >
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerHeader paddingY={0}>
                        <FacilitySidebarHeader isOpen userEmail={userEmail} />
                        <DrawerCloseButton />
                    </DrawerHeader>
                    <DrawerBody padding={0} overflowY="hidden">
                        <SearchWindow
                            areFiltersOpen={areFiltersOpen}
                            onFiltersToggle={onFiltersToggle}
                            tabIndex={tabIndex}
                            setTabIndex={setTabIndex}
                        />
                    </DrawerBody>
                </DrawerContent>
            </DrawerContainer>
        </>
    );
};

MobileFacilitySelectionMenu.propTypes = {
    areFiltersOpen: PropTypes.bool.isRequired,
    onFiltersToggle: PropTypes.func.isRequired,
    handleFacilitySelectionMenuToggel: PropTypes.func.isRequired,
    isFacilitiesMenuOpen: PropTypes.bool.isRequired,
    numberOfSelectedFacilities: PropTypes.number.isRequired,
    userEmail: PropTypes.string,
};

export default MobileFacilitySelectionMenu;
